<template>
  <div v-if="isIe || isDemo">
    <v-app
      v-if="block"
      class="ie-blocker--container"
      :class="{'mobile': $vuetify.breakpoint.smAndDown}"
    >
      <div class="ie-blocker--content d-flex justify-center">
        <slot name="blockContent">
          <v-card class="py-9 ie-blocker--card">
            <div class="d-flex flex-column align-center">
              <h2
                v-if="isDemo"
                class="mb-2"
              >
                [DEMO]
              </h2>
              <div class="d-flex justify-center pb-12">
                <div class="d-flex align-center justify-center icon-circle">
                  <v-icon
                    class="icon"
                    size="120px"
                  >
                    mdi-alert-circle-outline
                  </v-icon>
                </div>
              </div>
              <div class="mb-7">
                <div class="ie-blocker--not-compatible-text">
                  {{ appName }} is not compatible with this browser. 
                </div>
              </div>
              <div class="mb-3">
                <div 
                  v-if="publicApp"
                  class="ie-blocker--cta-text"
                >
                  Please use
                  <a
                    href="https://www.google.com/chrome/"
                    target="_blank"
                  >Google Chrome</a> or
                  <a
                    href="https://www.microsoft.com/en-us/edge"
                    target="_blank"
                  >Microsoft Edge</a> to continue.
                </div>
                
                <div
                  v-else
                  class="ie-blocker--cta-text"
                >
                  Please use
                  <a
                    href="https://www.google.com/chrome/"
                    target="_blank"
                  >Google Chrome</a> to continue.
                </div>
              </div>
            </div>
          </v-card>
        </slot>
      </div>
    </v-app>
    <div v-if="inline && !block">
      <slot name="blockContent">
        <Alert
          in-page
          :allow-dismiss="inlineDismissable"
          type="warning"
          :text="`${(isDemo?'[DEMO]':'')} You may experience issues running ${appName} in this browser.`"
          subtext="Google Chrome has been recommended as the default DoE browser for all platforms."
          action-text="GET GOOGLE CHROME"
          :action-handler="getChrome"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import Alert from "./Alert";

const isIe = () => {
  const ua = window.navigator.userAgent;
  // MSIE 10 or below || MSIE11.x
  return ua.indexOf("MSIE") !== -1 || !!navigator.userAgent.match(/Trident.*rv:11\./);
}

export default {
  name: "IeBlocker",
  components: {
    Alert
  },
  props: {
    appName: {
      type: String,
      default: "This application"
    },
    block: {
      type: Boolean,
      default: false
    },
    isDemo: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    inlineDismissable: {
      type: Boolean,
      default: false
    },
    publicApp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isIe() {
      return isIe();
    }
  },
  methods: {
    getChrome() {
      const win = window.open('https://www.google.com/chrome/', '_blank');
      win.focus();
    }
  },
  created() {
    if (this.isIe) {
      this.$emit("ieDetected");
    }
  },

  // export isIe function for use in regular js
  isIe: isIe
}
</script>

<style scoped>
  .ie-blocker--container.mobile {
    padding-top: 56px;
  }
  .ie-blocker--container {
    width: 100%;
    height: 100%;
    background-color: #E5E5E5 !important;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 10;
    padding-top: 100px;
    padding-left: 24px;
    padding-right: 24px;
  }
  .ie-blocker--content {
    min-width: 250px;
  }
  .ie-blocker--card {
    max-width: 640px;
    padding: 34px 100px;
    text-align: center;
  }
  .icon-circle {
    width: 185px;
    height: 185px;
    border-radius: 50%;
    background-color: #C8DCF0;
  }
  .icon {
    color: #041E42;
  }
  .ie-blocker--not-compatible-text {
    font-size: 24px;
    font-weight: bold;
    line-height: 2rem;
  }
</style>
